import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from 'react';
import './Snackbar.css';

export type SnackbarProps = {
  className?: string;
  children: ReactNode;
  [key: string]: any;
};

export const Snackbar = forwardRef(
  (
    { className: classNameProp, children }: SnackbarProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <div ref={ref} className={`snackbar ${classNameProp || ''}`} tabIndex={0}>
        {children}
      </div>
    );
  }
);
